module.exports = __webpack_public_path__ + "static/manage@3x-c506603af71f9927f57b54c467fbeb5f.png";